import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-04dffad9"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "page-warp" }
const _hoisted_2 = { class: "title-warp" }
const _hoisted_3 = { class: "base-info-warp d-flex" }
const _hoisted_4 = ["src"]
const _hoisted_5 = ["innerHTML"]
const _hoisted_6 = { class: "card" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "card-head" }, "活动信息卡", -1))
const _hoisted_8 = { class: "card-content" }
const _hoisted_9 = { class: "d-flex" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "card-label" }, "活动主持人", -1))
const _hoisted_11 = { class: "card-val" }
const _hoisted_12 = { class: "d-flex" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "card-label" }, "活动时间", -1))
const _hoisted_14 = { class: "card-val" }
const _hoisted_15 = { class: "d-flex" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "card-label" }, "联系电话", -1))
const _hoisted_17 = {
  key: 0,
  class: "card-val"
}
const _hoisted_18 = {
  key: 1,
  class: "card-val"
}
const _hoisted_19 = {
  key: 0,
  class: "d-flex"
}
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "card-label" }, "活动简介", -1))
const _hoisted_21 = { class: "card-val" }
const _hoisted_22 = { class: "d-flex" }
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "card-label" }, "活动地址", -1))
const _hoisted_24 = { class: "card-val" }
const _hoisted_25 = { class: "d-flex" }
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "card-label" }, "活动状态", -1))
const _hoisted_27 = {
  key: 0,
  class: "card-val"
}
const _hoisted_28 = {
  key: 1,
  class: "card-val"
}
const _hoisted_29 = {
  key: 2,
  class: "card-val"
}
const _hoisted_30 = { style: {"margin-top":"14px"} }
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "enroll-popup-head-warp" }, "报名信息", -1))
const _hoisted_32 = { class: "enroll-form-warp" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_van_button = _resolveComponent("van-button")!
  const _component_van_field = _resolveComponent("van-field")!
  const _component_van_radio = _resolveComponent("van-radio")!
  const _component_van_radio_group = _resolveComponent("van-radio-group")!
  const _component_van_cell_group = _resolveComponent("van-cell-group")!
  const _component_van_popup = _resolveComponent("van-popup")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("h2", _hoisted_2, _toDisplayString(_ctx.data.title), 1),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", null, [
        _createElementVNode("img", {
          src: _ctx.img(_ctx.data.headUrl)
        }, null, 8, _hoisted_4),
        _createTextVNode(" " + _toDisplayString(_ctx.data.userName), 1)
      ])
    ]),
    _createElementVNode("div", {
      innerHTML: _ctx.data.content,
      class: "content"
    }, null, 8, _hoisted_5),
    _createElementVNode("div", _hoisted_6, [
      _hoisted_7,
      _createElementVNode("div", _hoisted_8, [
        _createElementVNode("div", _hoisted_9, [
          _hoisted_10,
          _createElementVNode("div", _hoisted_11, _toDisplayString(_ctx.data.actHostUser), 1)
        ]),
        _createElementVNode("div", _hoisted_12, [
          _hoisted_13,
          _createElementVNode("div", _hoisted_14, _toDisplayString(_ctx.format(_ctx.data.startActTime, "yyyy-MM-dd HH:mm")) + "~" + _toDisplayString(_ctx.format(_ctx.data.endActTime, "yyyy-MM-dd HH:mm")), 1)
        ]),
        _createElementVNode("div", _hoisted_15, [
          _hoisted_16,
          (_ctx.data.isSignUp == true)
            ? (_openBlock(), _createElementBlock("div", _hoisted_17, _toDisplayString(_ctx.data.phone), 1))
            : _createCommentVNode("", true),
          (_ctx.data.isSignUp == false)
            ? (_openBlock(), _createElementBlock("div", _hoisted_18, " 成功报名后会显示联系电话 "))
            : _createCommentVNode("", true)
        ]),
        (_ctx.data.desc)
          ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
              _hoisted_20,
              _createElementVNode("div", _hoisted_21, _toDisplayString(_ctx.data.desc), 1)
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_22, [
          _hoisted_23,
          _createElementVNode("div", _hoisted_24, _toDisplayString(_ctx.data.province) + _toDisplayString(_ctx.data.city) + _toDisplayString(_ctx.data.district) + _toDisplayString(_ctx.data.address), 1)
        ]),
        _createElementVNode("div", _hoisted_25, [
          _hoisted_26,
          (_ctx.data.activityStatus == 1)
            ? (_openBlock(), _createElementBlock("div", _hoisted_27, "预约中"))
            : _createCommentVNode("", true),
          (_ctx.data.activityStatus == 2)
            ? (_openBlock(), _createElementBlock("div", _hoisted_28, "已开始"))
            : _createCommentVNode("", true),
          (_ctx.data.activityStatus == 3)
            ? (_openBlock(), _createElementBlock("div", _hoisted_29, "已结束"))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_30, [
          (_ctx.data.activityStatus == 1 && _ctx.data.isMy == false && _ctx.data.isSignUp == false && _ctx.data.isBlock == false)
            ? (_openBlock(), _createBlock(_component_van_button, {
                key: 0,
                style: {"width":"100%"},
                round: "",
                type: "success",
                size: "normal",
                color: "#FD5C02",
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.submitSignUp()))
              }, {
                default: _withCtx(() => [
                  _createTextVNode("马上报名 ")
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          (_ctx.data.activityStatus == 1 && _ctx.data.isMy == false && _ctx.data.isSignUp == true)
            ? (_openBlock(), _createBlock(_component_van_button, {
                key: 1,
                style: {"width":"100%"},
                round: "",
                type: "success",
                size: "normal",
                color: "#FD5C02",
                onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.submitCancelSignUp()))
              }, {
                default: _withCtx(() => [
                  _createTextVNode("取消报名 ")
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          (_ctx.data.activityStatus == 3 && _ctx.data.isMy == false)
            ? (_openBlock(), _createBlock(_component_van_button, {
                key: 2,
                style: {"width":"100%"},
                round: "",
                type: "success",
                size: "normal",
                color: "#FD5C02",
                disabled: ""
              }, {
                default: _withCtx(() => [
                  _createTextVNode("活动已结束（不能报名） ")
                ]),
                _: 1
              }))
            : _createCommentVNode("", true)
        ])
      ])
    ]),
    _createVNode(_component_van_popup, {
      show: _ctx.enroll.showPopup,
      "onUpdate:show": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.enroll.showPopup) = $event)),
      round: "",
      closeable: "",
      "close-icon": "close",
      position: "bottom"
    }, {
      default: _withCtx(() => [
        _hoisted_31,
        _createElementVNode("div", _hoisted_32, [
          _createVNode(_component_van_cell_group, {
            class: "enroll-cell-group",
            border: false
          }, {
            default: _withCtx(() => [
              _createVNode(_component_van_field, {
                maxlength: "20",
                modelValue: _ctx.enroll.form.userName,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.enroll.form.userName) = $event)),
                label: "家长姓名",
                placeholder: "请输入姓名"
              }, null, 8, ["modelValue"]),
              _createVNode(_component_van_field, {
                maxlength: "11",
                modelValue: _ctx.enroll.form.phone,
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.enroll.form.phone) = $event)),
                label: "联系电话",
                placeholder: "请输入联系电话"
              }, null, 8, ["modelValue"]),
              _createVNode(_component_van_field, {
                maxlength: "20",
                modelValue: _ctx.enroll.form.babyName,
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.enroll.form.babyName) = $event)),
                label: "宝贝姓名",
                placeholder: "请输入宝贝姓名"
              }, null, 8, ["modelValue"]),
              _createVNode(_component_van_field, {
                maxlength: "1",
                label: "宝贝性别"
              }, {
                input: _withCtx(() => [
                  _createVNode(_component_van_radio_group, {
                    modelValue: _ctx.enroll.form.babySex,
                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.enroll.form.babySex) = $event)),
                    direction: "horizontal"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_van_radio, { name: "男" }, {
                        default: _withCtx(() => [
                          _createTextVNode("男")
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_van_radio, { name: "女" }, {
                        default: _withCtx(() => [
                          _createTextVNode("女")
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }, 8, ["modelValue"])
                ]),
                _: 1
              }),
              _createVNode(_component_van_field, {
                maxlength: "2",
                modelValue: _ctx.enroll.form.babyAge,
                "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.enroll.form.babyAge) = $event)),
                label: "宝贝年龄",
                placeholder: "请输入宝贝年龄"
              }, null, 8, ["modelValue"]),
              _createVNode(_component_van_field, {
                maxlength: "20",
                modelValue: _ctx.enroll.form.community,
                "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.enroll.form.community) = $event)),
                label: "所在社区",
                placeholder: "请输入所在社区"
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          }),
          _createVNode(_component_van_button, {
            onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.submitActSignUp())),
            type: "primary",
            block: "",
            color: "#FD5C02"
          }, {
            default: _withCtx(() => [
              _createTextVNode("确认报名")
            ]),
            _: 1
          })
        ])
      ]),
      _: 1
    }, 8, ["show"])
  ]))
}